import React from "react"

import Layout from "../../components/layout"
import SEO from "../../components/seo"

const pratiqueSophrologie = () => {
  return (
    <Layout>
      <SEO title="Comment se pratique la sophrologie ?" />
      <div className="container py-5">
        <div className="row">
          <div className="col-md-12 mb-5">
            <h2>Comment se pratique la sophrologie&nbsp;?</h2>
          </div>
          <div className="col-md-12">
            <p>
              La sophrologie se pratique assis ou debout, selon les possibilités
              du moment. Chacun est libre d’effectuer ou non les mouvements
              proposés par le praticien, selon ses capacités du moment. La
              sophrologie est une méthode pédagogique douce et progressive,
              respectueuse des possibilités et des limites de chacun. C’est
              pourquoi elle peut se pratiquer à tout âge de la vie, à partir de
              5 ans et sans limite d’âge.
            </p>
            <p>
              Il est conseillé de s’entraîner à refaire les techniques en dehors
              des consultations ou des ateliers et d’intégrer leur pratique
              régulière dans sa vie quotidienne pour pérenniser les bienfaits de
              cette méthode. L’objectif est de devenir autonome.
            </p>
            <p>
              On peut pratiquer la sophrologie en séances individuelles ou en
              ateliers collectifs.
            </p>
            <p>
              La séance individuelle est personnalisée, en réponse à une demande
              ou une problématique particulière (troubles du sommeil, angoisse,
              manque de confiance en soi, douleurs chroniques,…). Elle est
              réalisée en cabinet ou à votre domicile, sur rendez-vous, et dure
              une heure environ.
            </p>
            <p>
              Les séances collectives portent sur des thématiques pré-définies,
              selon l’origine du groupe, dans lesquelles chacun pourra prendre
              ce dont il a besoin. Dans tous les cas, l’échange qui précède
              toujours la pratique permet au sophrologue de proposer une séance
              tenant compte des attentes du groupe.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default pratiqueSophrologie
